module.exports = __webpack_public_path__ + "img/prepayment.25c316ce.svg";